<template>
  <div class="label snappy-badge" :class="`snappy-badge--${background}`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'snappy-badge',
  props: {
    name: {
      type: String,
    },
    background: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../sass/web/_variables.scss';

.snappy-badge {
  font-size: 12px;
  line-height: 16px;
  border-radius: 4px;
  padding: 8px 12px;

  &--green {
    background: #afe197;
    color: #006900;
  }

  &--red {
    background: rgba($deep-carmine-pink-color, 0.5);
    color: #b10300;
  }

  &--grey {
    background: #e9e9e9;
    color: $grey-cloud-color;
  }
}
</style>
